export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4773.70f5f7c8.jpg";